import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, Link, Redirect } from "react-router-dom";
/** Layout components */
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Paper,Table,TableContainer,TableCell,TableHead,TableRow,TableBody} from '@material-ui/core';
import {
    TextField, Button, Icon, Snackbar, Input,
    MenuItem, FormControl, Select, Grid, CardHeader, CircularProgress,
    IconButton, Typography, Tooltip, makeStyles
} from '@material-ui/core';
import { Alert, Badge, Card, Modal, ProgressBar } from "react-bootstrap";
import { CardBody } from "../../../_metronic/_partials/controls";
import AlertHelper from '../Alert';
import Editor from "../Editor";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';

/** Icones */
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";

/** Helpers functions */
import { isJson } from '../../helpers/json';
import { isEmptyArray, swapArray } from '../../helpers/array';
import { recursiveGetMachinesByKey, parse } from '../../helpers/three';
import { getUserAccessLevel } from "../../helpers/role";
import { setErrorMessageInInputs } from '../../helpers/validations';

/** Redux */
import { createApproval, getApproversAPI } from '../../pages/ApprovalFlow/_redux/ApprovalCrud'
import { updateTraining, createTraining } from '../../pages/Training/_redux/TrainingCrud'
import { fetchStructure } from '../../pages/Structure/_redux/action';
import { fetchOpenWorkflow } from '../../pages/Workflow/_redux/requests';
import { fetchTrainingUsers } from '../../pages/Training/_redux/requests';

/** Default system functions  */
import { getUserFactoryId, getUser, getUserId, getStructureTree } from '../../../index';
import buildQuery from "odata-query";
import api from '../../services/api';
import _, { orderBy, set, cloneDeep } from 'lodash';

/** css */
import '../../../../node_modules/react-simple-tree-menu/dist/main.css';
import { Loading } from "../Loading/Loading"
import { isToday } from "date-fns";

/** pickers **/
import { Render } from '../Render/Render'
import { PdfRender } from '../Render/PdfRender';

import { GalleryLightbox } from '../../components/Gallery';
import { ExternalStandardModal } from '../../components/StandardView/Modal/ExternalStandardModal';
import { SelectAsyncPaginateGeneric } from '../../components/Select/SelectAsyncPaginateGeneric';
import BackButton from '../../components/BackButton/BackButton'
import { withStyles } from '@material-ui/core';
import { TrainingTable } from '../Training'

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },

}));



const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 15,
        whiteSpace: 'pre-line'
    },
}))(Tooltip);

const externalStandardOptions =
    [
        {
            "key": 1,
            "value": 'LPP'
        },
        {
            "key": 2,
            "value": 'DTP'
        },
        {
            "key": 3,
            "value": 'IDCARD'
        },
        {
            "key": 4,
            "value": 'TRAININGMATERIAL'
        }
    ];

export default function StandardNew(defaultDadosBasicos, props, newstd, fetchDataView, standardType = 'lpp') {
    //console.log(defaultDadosBasicos);
    const classes = useStyles();

    const dispatch = useDispatch();
    const mediatoken = localStorage.getItem('mediatoken');
    const allStructuresData = useSelector(state => state.structure.entities);
    const setorLinhaData = allStructuresData.filter(x => (x.typeId != 8 && x.typeId != 9))
    const [standard, setStandard] = useState(newstd);
    const [treeData, setTreeData] = useState([]);
    const [machine, setMachine] = useState([]);
    const [redirect, setRedirect] = useState('/new/0');
    const [dadosBasicos, setDadosBasicos] = useState(defaultDadosBasicos);
    const [epis, setEpis] = useState([]);
    const [tools, setTools] = useState([]);
    const [lpps, setLpps] = useState([]);
    const [modal, setModal] = useState();
    const [modalIdcardStatus, setModalIdcardStatus] = useState(false);
    const [dadosIdcardStatus, setDadosIdcardStatus] = useState([[], []]);
    const [setores, setSetores] = useState([]);
    const [usersToUse, setUsersToUse] = useState([]);
    const [filtersPopup, setFiltersPopup] = useState([]);
    const [modalUser, setModalUser] = useState();
    const [load, setLoad] = useState(false);
    const [archiveView, setArchiveView] = useState(true);
    const [workFlowOnline, setWorkflowOnline] = useState(true);

    const [testeSnack, setTesteSnack] = useState(false);

    const [progressNumber, setProgressNumber] = useState(0);

    const [imgstate, setImgState] = useState([]);

    const [isSaving, setIsSaving] = useState(false);
    const [isCloning, setIsCloning] = useState(false);

    const [show, setShow] = useState();
    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });
    const [showAlert, setShowAlert] = useState(null)
    const userAcessLevel = getUserAccessLevel();
    const childRef = useRef();

    const initStateErrors = {
        hasError: false,
        Name: "",
        Structure: "",
        station: "",
        productActivity: "",
        alertProcedure: ""
    };

    const [errors, setErrors] = useState(initStateErrors);

    const [templates, setTemplates] = useState([]);

    const images = [{
        'url': '/media/RPN.png',
        'title': 'ID Card RPN'
    }];

    const [instructionRPN, setInstructionRPN] = useState(false);

    const [getUsersFromAPI, setGetUsersFromAPI] = useState(false);

    const [change, set] = useState(0)
    const [initializeUserVector, setInitializeUserVector] = useState(false)

    const authorAlreadyTrained = {
        userId: getUser().id,
        status: true,
        user: getUser(),
        isInFarol: true
    }

    const [modalMatrixUsers, setModalMatrixUsers] = useState(false);
    const [listTrainingUsers, setListTrainingUsers] = useState([]);
    const [listUserMatrix, setListUserMatrix] = useState([]);
    const [for_approval, setFor_approval] = useState(false);
    const [bypassApprovalFlow, setBypassApprovalFlow] = useState(false);
    const [for_training, setFor_training] = useState(false);

    useEffect(() => {

        async function getDataStructureTree() {
            // Get structures
            dispatch(fetchStructure());
            const structuresTree = await getStructureTree()
            setTreeData(parse(structuresTree.structures))
        }

        function setupNewLPP() {
            const id = (props.match.params.id)
            // Vrifica se já existe step no standar
            if (id === '0' && standard.steps.length < 1) {
                const newStep = {
                    objects: [],
                    content: "[]",
                    stepTypeId: 2,
                    name: '',
                    duration: "0",
                    numero: 1,
                    instruction: ''
                }
                setStandard({
                    ...standard,
                    steps: [...standard.steps, newStep],
                    trainingUsers: [...standard.trainingUsers, authorAlreadyTrained]
                })
            }
        }

        function setupNewDTP() {
            const id = (props.match.params.id)

            if (id === '0') {
                setStandard({
                    ...standard,
                    trainingUsers: [...standard.trainingUsers, authorAlreadyTrained]
                })
                getEquipments();
            }
        }

        function setupNewIdcard() {

            const defaultStatus = [
                [{
                    name: 'toolElimination',
                    desc: 'Ferramenta utilizada para eliminação',
                    class: 'col-12',
                },
                {
                    name: 'killerAction',
                    desc: 'Ação matadora',
                    class: 'col-12',
                },
                {
                    name: 'eliminatedAt',
                    desc: 'Data eliminação',
                    class: 'date',
                }],
                [{
                    name: 'reactivationReason',
                    desc: 'Motivo da Reativação',
                    class: 'col-12',
                },
                {
                    name: 'reactivationSource',
                    desc: 'Fonte da Reativação',
                    class: 'col-12',
                },
                {
                    name: 'reactivateAt',
                    desc: 'Data Reativação',
                    class: 'date',
                }]


            ]

            setDadosIdcardStatus(defaultStatus);

            const id = (props.match.params.id);
            if (id === '0') {
                const newStep = {
                    objects: [],
                    content: "[]",
                    stepTypeId: 2,
                    name: '',
                    duration: "0",
                    numero: 1,
                    instruction: ''
                }
                const idx = dadosBasicos.findIndex(i => i.name == 'defectCategoryId');
                let initialDefectCategory = '';
                if (idx > -1 && dadosBasicos[idx].options.length > 0) {
                    let initialDefectCategory = dadosBasicos[idx].options[0].value;
                }
                if (initialDefectCategory != '') {
                    setStandard({
                        ...standard,
                        status: 1,
                        standardType: "IDCARD",
                        defectCategory: initialDefectCategory,
                        //speciality: "Educação e Treinamento",
                        steps: [...standard.steps, newStep],
                        trainingUsers: [...standard.trainingUsers, authorAlreadyTrained]
                    })
                }
                else {
                    setStandard({
                        ...standard,
                        status: 1,
                        standardType: "IDCARD",
                        //speciality: "Educação e Treinamento",
                        steps: [...standard.steps, newStep],
                        trainingUsers: [...standard.trainingUsers, authorAlreadyTrained]
                    })
                }
            }
        }

        function setupNewTrainingMaterial() {
            const id = (props.match.params.id)
            if (id === '0') {
                const newStep = {
                    objects: [],
                    content: "[]",
                    stepTypeId: 4,
                    name: '',
                    duration: "0",
                    numero: 1,
                    instruction: ''
                }
                setStandard({
                    ...newstd,
                    steps: [...standard.steps, newStep],
                    trainingUsers: [...standard.trainingUsers, authorAlreadyTrained]
                })
            }
        }

        function getEquipments() {
            if (epis.length != 0)
                return;
            return api
                .get(`/ImageStore/odata?$orderby=name asc`)
                .then(response => {

                    let equipamentsStructures = response.data.value;

                    //equipamentsStructures = _.orderBy(equipamentsStructures, ['name'],['asc'])

                    let epis = equipamentsStructures.filter((item) => {
                        return item.type === 0
                    });
                    let tools = equipamentsStructures.filter((item) => {
                        return item.type === 1 || item.type === 3
                    });

                    setEpis(epis);
                    setTools(tools);
                })
                .catch(error => {
                    ShowError("Erro na localização de equipamentos, tente novamente!");
                });
        }

        getTemplates();

        getDataStructureTree();

        if (standardType === 'lpp') { setupNewLPP(); }
        if (standardType === 'dtp') { setupNewDTP(); }
        if (standardType === 'idcard') { setupNewIdcard(); }
        if (standardType === 'TrainingMaterial') { setupNewTrainingMaterial(); }


    }, [])

    useEffect(() => {
        if (templates.length > 0) {
            const id = props.match.params.id;
            //if (standardType === 'lpp' && id === '0' && templates[0]) selectTemplate(templates[0].standardClassification)

            if (standardType === 'idcard' && id === '0' && templates[5]) selectTemplate('ID Card')
        }
    }, [templates])

    useEffect(() => {
        if (allStructuresData.length > 0 && standardType == 'idcard') {
            //console.log('idcard', allStructuresData)
            const machines = allStructuresData.filter(x => (x.typeId == 8))
            setMachine(machines)
        }
    }, [allStructuresData])

    useEffect(() => {

        function getUsersToUse() {
            setLoad(true)
            return api.get('user/odata' + buildQuery({
                filter: {
                    factoryId: parseInt(getUserFactoryId()),
                    status: true
                },
                select: ['name', 'sap', 'id'],
                expand: {
                    companyRole: {
                        select: ['name']
                    },
                    Deparment: {
                        select: ['id', 'name']
                    }
                },
                orderBy: ["name asc"]
            }
            )).then(response => {
                for (var i = 0; i < response.data.value.length; i++) {
                    response.data.value[i].originalIndex = i;
                }
                setUsersToUse(response.data.value);

                let departmentWithPeople = response.data;
                let arrayTemp = []

                allStructuresData.map((e) => {
                    var structureHasOneUser = departmentWithPeople.value.filter((item) => item.deparment?.id == e.id)
                    if (structureHasOneUser.length > 0)
                        arrayTemp.push({
                            name: e.name + (e.father ? ' (' + e.father.name + ')' : ''),
                            value: e.id,
                            id: e.id
                        })
                })

                setSetores(arrayTemp);

                setLoad(false)
            }).catch(error => {
                ShowError("Erro na localização da colaboradores! Você pode salvar o documento e incluir o treinamento depois");
            });
        }

        if (getUsersFromAPI && usersToUse.length == 0) {
            getUsersToUse();
        }

    }, [getUsersFromAPI])

    function getTemplates() {
        return api
            .get('/template')
            .then(response => {
                const templates = response.data;
                setTemplates(templates);
            })
            .catch(error => {
                console.log("Erro na localização dos Templates");
            });
    }

    useLayoutEffect(() => {
        const id = props.match.params.id;
        if (id !== '0') {
            getStandardData();
        } else {
            setIsSaving(false);
            setWorkflowOnline(false);
        }

        async function getStandardData() {
            let cloning = false;
            if (props.match.url.includes('clone')) {
                cloning = true;
                setIsCloning(cloning)
            }
            setIsSaving(true);
            let std;
            try {
                const res = await fetchDataView(id);
                std = res.data.value[0];
                if (cloning)
                    std.userId = getUser().id;
                //console.log(std)
                if (validatePermissionToEdit(getUser().id, std) == false) {
                    return;
                }
            }
            catch (e) {
                ShowError("Erro na localização de " + standardType + ", tente novamente!");
            }

            std.id = std.standardId
            std.StructureId = std.structureId
            std.images = [];
            std.lpps = [];
            // _.orderBy(dtp.steps, ['numero'], ['asc']).map((el, key) => (
            //std.steps.map((step) => {
            const orderedSteps = _.orderBy(std.steps, [(steps) => steps.numero], ['asc'])
            std.steps = orderedSteps;
            std.steps.map((step) => {
                if (cloning) {
                    delete step.id;
                    delete step.standardId
                }
                const objs = (isJson(step.content)) ? JSON.parse(step.content) : [];
                objs.map((obj) => {
                    if (obj.type === "img") {
                        std.images.push(obj.src)
                    }
                })
            })

            std.epis = [];
            std.tools = [];

            if (typeof std.equipments !== 'undefined') {
                let equipamentsStructures
                try {
                    const response = await api.get(`/ImageStore/odata?$orderby=name asc`)
                    equipamentsStructures = response.data.value;
                } catch (e) {
                    ShowError("Erro na localização de equipamentos, tente novamente!");
                }

                let epis = equipamentsStructures.filter((item) => {
                    return item.type === 0
                });
                let tools = equipamentsStructures.filter((item) => {
                    return item.type === 1 || item.type === 3
                });

                setEpis(epis);
                setTools(tools);

                //console.log(standard.name)
                //console.log(standard.station)

                std.equipments.map((equ) => {

                    let isItEPI = epis.filter((item) => {
                        return item.id === equ.equipmentId
                    });

                    //console.log(isItEPI)

                    if (isItEPI.length > 0) {
                        std.epis.push({
                            name: isItEPI[0].name,
                            type: isItEPI[0].type,
                            equipmentId: equ.equipmentId,
                            photo: isItEPI[0].photo
                        })
                    }
                    else {
                        let isItTools = tools.filter((item) => {
                            return item.id === equ.equipmentId
                        });
                        //console.log(isItTools)
                        std.tools.push({
                            name: isItTools[0].name,
                            type: isItTools[0].type,
                            equipmentId: equ.equipmentId,
                            photo: isItTools[0].photo
                        })
                    }
                })
            }

            delete std.updatedAt;

            if (cloning) {
                delete std.id;
                delete std.identifier;
                delete std.number;
                delete std.processSituation;
                delete std.status;
                delete std.standard;
                delete std.user;
                delete std.trainingUsers;
                std.StructureId = 0;
                std.version = 0;
                std.trainingUsers = [authorAlreadyTrained];
                setStandard(std);
                setWorkflowOnline(false);
            }
            else {

                try {
                    let resOpenWorkflow = await fetchOpenWorkflow(std.id);
                    if (resOpenWorkflow != false) {
                        resOpenWorkflow.editable = true;

                        const workflowOnline = resOpenWorkflow.users.filter((item) => {
                            return (item.situation == 2 || item.situation == 3)
                        });
                        if (workflowOnline.length > 0) {
                            resOpenWorkflow.editable = false;
                        }
                        //console.log('workflow', resOpenWorkflow)
                    }

                    setWorkflowOnline(resOpenWorkflow);

                } catch (e) {
                    ShowError("Erro na localização de workflows abertos!");
                }
                try {
                    const resTrainingUsers = await fetchTrainingUsers(id);
                    std.trainingUsers = resTrainingUsers.data.value;
                } catch (e) {
                    ShowError("Erro de pessoas para treinamento!");
                }

                setStandard(std);
            }

            setIsSaving(false);
        }
    }, [])

    function validatePermissionToEdit(currentUserId, standardData) {
        //console.log(currentUserId)
        //console.log(standardData)
        if (props.match.url.includes('clone'))
            return true;

        if (currentUserId != standardData.userId && getUserAccessLevel() < 7) {
            let msgError = "Acesso não permitido!";
            setShowAlert({ variant: 'info', message: msgError })
            console.error(msgError)
            setTimeout(() => {
                setRedirect('/home');
            }, 10000);
            return false;
        }

        return true;
    }

    const types = [
        { stepTypeId: 1, stepType: "mp4" },
        { stepTypeId: 2, stepType: "json" },
        { stepTypeId: 7, stepType: "docx" },
        { stepTypeId: 8, stepType: "xlsx" },
        { stepTypeId: 9, stepType: "pptx" },
        { stepTypeId: 4, stepType: "pdf" },
        { stepTypeId: 99, stepType: "mp4" },
    ]

    const handleCloseMatrixUser = (() =>{
        setModalMatrixUsers(false);
        saveData(for_approval, bypassApprovalFlow, for_training, false)
    }) 

    async function handleMatrixUsersConfirm(){
        setModalMatrixUsers(false);
        saveData(for_approval, bypassApprovalFlow, for_training, true)
    }

    async function BeforeSaveData(for_approval = false, bypassApprovalFlow = false, for_training = false){
        setIsSaving(true);
        setFor_approval(for_approval);
        setBypassApprovalFlow(bypassApprovalFlow);
        setFor_training(for_training);
        if(props.match.params.id === '0'){
            await api.get(`/CommunicationExternalSystem/MCsetor/${standard.StructureId}`).then(
                (tes) => {
                    var list = [];
                    tes.data.forEach((element) => {
                        var TrainingUserInsert = {
                            UserId: element.id,
                            ExternalMaterialId: null,
                            Proof: "",
                            Status: false,
                            IsInFarol: true,
                            FarolLvl20: false,
                            FarolLvl202: false,
                            FarolLvl70: false,
                        }
                        list.push(TrainingUserInsert);
                    });

                    setListTrainingUsers(list);
                    setListUserMatrix(tes.data);
                    setModalMatrixUsers(true);
                }
            ).catch(
                ({ response }) => {
                    ShowError("Não achou os Colaboradores da Matrix");
                    saveData(for_approval, bypassApprovalFlow, for_training);
                }
            );
        }else{
            saveData(for_approval, bypassApprovalFlow, for_training);
        }
    }

    function saveData(for_approval = false, bypassApprovalFlow = false, for_training = false, confirm = false) {
        setIsSaving(true);

        console.log(standard)

        var newstandard = _.cloneDeep(standard);
        //newstandard = JSON.parse(JSON.stringify(standard));

        if(confirm){
            newstandard.trainingUsers = listTrainingUsers;
        }

        //cria content (string) dos objetos de cada step
        var result = newstandard.steps.map((step, idx) => {
            step.numero = idx + 1;
            if (step.stepTypeId === 2 && step.objects) {
                step.content = JSON.stringify(step.objects)
                /*const svgObj = document.getElementById('svgObj').outerHTML;
                console.log('step.objects', step.objects);
                if (!isEmptyArray(step.objects)) {
                  if (step.objects[step.objects.length - 1].type !== 'svg') {
                    step.objects.push({id: 0, type: 'svg', svg: svgObj});
                    step.content = JSON.stringify(step.objects);
                  } else {
                    step.objects[step.objects.length - 1] = {id: 0, type: 'svg', svg: svgObj}
                  }
                }*/
            }

            return step
        })

        let equipments = [];

        newstandard.epis.forEach((element, idx) => {
            if (newstandard.epis[idx].equipmentId)
                equipments.push({ equipmentId: newstandard.epis[idx].equipmentId })
        })

        newstandard.tools.forEach((element, idx) => {
            if (newstandard.tools[idx].equipmentId)
                equipments.push({ equipmentId: newstandard.tools[idx].equipmentId })
        })

        newstandard.trainingUsers.forEach((element, idx) => {
            delete element.user
            if (element.userId == getUserId())
                element.status = true;
            else
                element.status = false;
        })

        //newstandard.userId = getUser().id;

        delete newstandard.structure;
        newstandard.steps = result;
        newstandard.equipments = equipments;

        let copyErrors = { ...initStateErrors };
        copyErrors['hasError'] = false;

        let currentStructureType = '';
        if (newstandard.StructureId && allStructuresData.length > 0) {
            currentStructureType = _.first(allStructuresData.filter((item) => {
                return item.id === newstandard.StructureId
            }));
            //console.log(currentStructureType)
        }

        ///SE nao tiver selecionado estrutura, 
        //ou se for id card e a estrutura selecionado nao for uma maquina (typeId != 8)
        if (!newstandard.StructureId ||
            (standardType.toLocaleLowerCase() == "idcard" && currentStructureType.typeId != 8)) {
            if (standardType.toLocaleLowerCase() == "idcard") {
                copyErrors['Machines'] = 'Necessário selecionar uma Máquina para o IDCard!';
            }
            copyErrors['Structure'] = 'Necessário selecionar Estrutura!';
            copyErrors["hasError"] = true;
            console.log('Structure')
            ShowError("Preencha todos os campos (Setor/Linha) para salvar a " + standardType);

            setErrors(copyErrors);
            return 0;
        } else {
            if (!newstandard.name) {
                copyErrors['Name'] = 'Necessário digitar o Nome!';
                copyErrors["hasError"] = true;
                console.log('Nome')
                ShowError("Preencha todos os campos (Nome) para salvar a " + standardType);

                setErrors(copyErrors);
                return 0;
            } else {
                if (standardType === 'lpp') {

                    if (newstandard.applicableToNewColleague == null || newstandard.applicableToNewColleague == 'Selecione uma opção') {
                        copyErrors['applicableToNewColleague'] = 'Necessário escolher se aplicável a novo colaborador!';
                        copyErrors["hasError"] = true;
                        ShowError("Preencha todos os campos (aplicável a novo colaborador) para salvar a " + standardType);
                    }

                    if (newstandard.pilar == undefined || newstandard.pilar == 'Selecione uma opção') {
                        copyErrors['pilar'] = 'Necessário escolher o pilar!';
                        copyErrors["hasError"] = true;
                        ShowError("Preencha todos os campos (Pilar) para salvar a " + standardType);
                    }

                    if (newstandard.classification == undefined || newstandard.classification == 'Selecione uma opção') {
                        copyErrors['classification'] = 'Necessário escolher a classificação!';
                        copyErrors["hasError"] = true;
                        ShowError("Preencha todos os campos (Classificação) para salvar a " + standardType);
                    }

                    if (newstandard.transfer == undefined || newstandard.transfer == 'Selecione uma opção') {
                        copyErrors['transfer'] = 'Necessário escolher se é transferência de atividade!';
                        copyErrors["hasError"] = true;
                        ShowError("Preencha todos os campos (Transferência) para salvar a " + standardType);
                    }

                    if (copyErrors["hasError"]) {
                        setErrors(copyErrors);
                        console.log('lpp', copyErrors)
                        return 0;
                    }
                }
                if (standardType === 'dtp') {

                    if (newstandard.station === '') {
                        copyErrors['station'] = 'Necessário digitar o Posto!';
                        copyErrors["hasError"] = true;
                        console.log('Posto')
                    }

                    if (newstandard.productActivity === '') {
                        copyErrors['productActivity'] = 'Necessário digitar o Produto ou Tarefa!';
                        copyErrors["hasError"] = true;
                        console.log('Produto')
                    }

                    if (newstandard.alertProcedure === '') {
                        copyErrors['alertProcedure'] = 'Necessário digitar o Procedimento de Alerta!';
                        copyErrors["hasError"] = true;
                        console.log('Alerta')
                    }

                    if (newstandard.steps.length > 0) {
                        for (var i = 0; i < newstandard.steps.length; i++) {
                            if (newstandard.steps[i].content.length <= 3) {
                                copyErrors['stepError'] = 'Necessário desenhar os passos!';
                                copyErrors["hasError"] = true;
                                console.log('Passos')
                            }
                        }
                    }

                    if (copyErrors["hasError"]) {
                        setErrors(copyErrors);
                        console.log('hasError')
                        if (copyErrors['stepError'] == 'Necessário desenhar os passos!')
                            ShowError("Necessário desenhar os passos para salvar a " + standardType);
                        else
                            ShowError("Preencha todos os campos para salvar a " + standardType);
                        return 0;
                    }
                }
                if (standardType === 'idcard') {
                    delete newstandard.product;
                    delete newstandard.defectType;
                    delete newstandard.defectCategory;
                    if (newstandard.productId === 0) {
                        copyErrors['product'] = 'Necessário escolher o Produto!';
                        copyErrors["hasError"] = true;
                        console.log('Produto')
                    }

                    if (newstandard.defectSource === '') {
                        copyErrors['defectSource'] = 'Necessário digitar a Fonte do Modo de Defeito!';
                        copyErrors["hasError"] = true;
                        console.log('defectSource')
                    }

                    if (newstandard.defectMode === '') {
                        copyErrors['defectMode'] = 'Necessário digitar o Modo de Defeito!';
                        copyErrors["hasError"] = true;
                        console.log('defectMode')
                    }

                    if (newstandard.description === '') {
                        copyErrors['description'] = 'Necessário digitar a Descrição do Modo de Defeito!';
                        copyErrors["hasError"] = true;
                        console.log('description')
                    }

                    if (newstandard.eliminated == true &&
                            (newstandard.eliminatedAt == null ||
                            newstandard.killerAction == '' ||
                            newstandard.toolElimination == '' )) {
                        ShowError("IDCard eliminado mas falta dados. Preencha todos os campos da eliminação para salvar o " + standardType);
                        return 0;
                    }

                    if (newstandard.eliminated == false &&
                        (newstandard.reactivateAt != null ||
                        newstandard.reactivationReason != '' ||
                        newstandard.reactivationSource != '') &&
                        (newstandard.reactivateAt == null ||
                        newstandard.reactivationReason == '' ||
                        newstandard.reactivationSource == '' )) {
                        ShowError("IDCard reativado mas falta dados. Preencha todos os campos da reativação para salvar o " + standardType);
                        return 0;
                    }

                    if (copyErrors["hasError"]) {
                        setErrors(copyErrors);
                        console.log('hasError')
                        ShowError("Preencha todos os campos para salvar a " + standardType);
                        return 0;
                    }
                }
                if (standardType === 'TrainingMaterial') {
                    delete newstandard.pillarResponsibility;

                    if (newstandard.materialDescription === '') {
                        copyErrors['materialDescription'] = 'Necessário digitar a descrição!';
                        copyErrors["hasError"] = true;
                    }

                    if (copyErrors["hasError"]) {
                        setErrors(copyErrors);
                        console.log('TrainingMaterial')
                        ShowError("Preencha todos os campos para salvar a " + standardType);
                        return 0;
                    }

                    switch (newstandard.category) {
                        default:
                        case 'Compliance':
                            newstandard.pillarResponsibilityId = null;
                            break;
                        case 'Outros':
                            newstandard.compliance = 'N/A';
                            newstandard.pillarResponsibilityId = null;
                            break;
                        case 'NCE':
                            newstandard.compliance = 'N/A';
                            if (newstandard.pillarResponsibilityId == null) {
                                const idx = dadosBasicos.findIndex(i => i.name === 'pillarResponsibilityId');
                                newstandard.pillarResponsibilityId = dadosBasicos[idx].options[0].key
                            }
                            break;
                    }
                }

                for (var i = 0; i < newstandard.steps?.length; i++) {
                    if (newstandard.steps[i].content == '[]' && newstandard.steps[i].stepTypeId === 1) {
                        copyErrors['steps'] = 'Vídeo não carregou possivelmente devido a um erro de conexão. Favor tentar novamente.';
                        copyErrors["hasError"] = true;
                        console.log('description')
                        break;
                    }
                }

                if (newstandard.id) {
                    delete newstandard.standard
                    delete newstandard.images
                    delete newstandard.lpps
                    delete newstandard.user
                    delete newstandard.structure
                    if (newstandard.processSituation == 1 || newstandard.processSituation == 0)
                        newstandard.version = newstandard.version - 1;
                    api.put(standardType, newstandard).then((res) => {
                        setErrors({ ...copyErrors, hasError: false });
                        AfterSaveRequest(res, for_approval, bypassApprovalFlow, true, for_training);
                    }).catch(({ response }) => {
                        //let  data = response.data;
                        console.log('standard.id')
                        ShowError("Preencha todos os campos para atualizar a " + standardType);
                        setErrorMessageInInputs(response.data || [], copyErrors, setErrors);
                    })
                } else {
                    delete newstandard.structure
                    newstandard.version = 0;
                    api.post(standardType, newstandard).then((res) => {
                        standard.id = res.data.id
                        setErrors({ ...copyErrors, hasError: false });
                        AfterSaveRequest(res, for_approval, bypassApprovalFlow, false, for_training);
                    }).catch(({ response }) => {
                        console.log(response);
                        ShowError("Preencha todos os campos para salvar a " + standardType);
                        setErrorMessageInInputs(response.data || [], copyErrors, setErrors);
                    })
                }
            }
        }

    }
    
    async function AfterSaveRequest(res, for_approval, bypassApprovalFlow, exists, for_training) {
        console.log('responseAfterSave', res.data);

        if (for_training) {
            ShowError("Documento salvo.", "success");
            if (exists) {
                setRedirect(`/edittraining/${standard.identifier}`);
                return;
            }
            else {
                setRedirect(`/edittraining/${res.data.identifier}`);
                return;
            }
        }

        if (!for_approval) {
            ShowError("Documento salvo.", "success");
            if (!exists) {
                window.location.href = `/${standardType}/new/${res.data.id + 1}`;
                //setRedirect(`/${standardType}/new/${res.data.id + 1}`);
                return;
            }
            else
                return;
        }

        let workflow = await prepareWorkflow(res.data.id)
        if (workflow === null)
            return false;

        if (bypassApprovalFlow && workFlowOnline) {
            //to-do get workflow and approve it
        }
        else {
            createApproval(workflow).then((responseWorkflow) => {
                if (!bypassApprovalFlow) {
                    setRedirect('/approval/' + responseWorkflow.data.id);
                } else {
                    //auto aprovação, superadmin
                    workflow.id = responseWorkflow.data.id
                    workflow.users = [
                        {
                            userId: getUser().id,
                            order: 1,
                            situation: 2
                        }
                    ];
                    api.put('/workflow', workflow).then((resWorkflow) => {
                        setRedirect('/' + standardType + '/' + res.data.id);
                    }).catch(({ response }) => {
                        ShowError("Erro ao salvar Fluxo de Aprovação, tente novamente!");
                    })
                    //auto aprovação, superadmin
                }
            })
                .catch(({ response }) => {
                    ShowError("Erro ao salvar Fluxo de Aprovação, tente novamente!");
                    setRedirect('/standard');
                })
        }

    }

    async function prepareWorkflow(standardId) {

        let structureResponsibleIdWorkflow = null;

        let standardClassification = '';
        switch (standard.standardType.toLowerCase()) {
            case 'lpp':
                standardClassification = standard.pilar
                break;
            case 'dtp':
                standardClassification = 'DTP P'
                break;
            case 'idc':
            case 'idcard':
                standardClassification = 'IDCARD'
                break;
            case 'trainingmaterial':
                standardClassification = 'TRAININGMATERIAL'
                break;
        }

        let workflow = {
            standardId: standardId,
            situation: 'NotStarted',
            standardClassification: standardClassification,
            users: []
        }

        /*Removida criação automatica do fluxo de aprovação
        let responseApprovers = await getApproversAPI(getUserFactoryId(), standard.standardType.toLowerCase(), standardClassification, structureResponsibleIdWorkflow);
        responseApprovers.data.value.forEach((id, idx) => {
            workflow.users.push({
                UserId: responseApprovers.data.value[idx].userId,
                Order: 1,
                Situation: 'Pending'
            })
        })

        if (workflow.users.length === 0) {
            ShowError("Erro ao obter aprovadores do padrão, tente novamente!");
            return null;
        }

        //workflow.users = usersGetApprover;
        */
        return workflow;
    }

    function ShowError(msgError, type = 'error') {

        setIsSaving(false);
        setSnackBar({ ...snackBar, isOpen: true, message: msgError, type })
    }

    function handleChange(newStd, idx = 0) {
        setStandard(newStd);
        //console.log('alteração ' + idx + ' - ' + newStd.lastStepEdited)
    }

    function handleChangeStep(newstep, idx) {
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleSwapSteps(orig, dest) {
        setStandard((oldValue) => {
            swapArray(oldValue.steps, orig, dest)
            return {
                ...oldValue
            }
        })
    }

    function newStep() {
        const template = templates.find(t => t.standardClassification === 'DTP');

        if (standardType === 'TrainingMaterial')
            template.content = '';
        let stepTypeId;
        switch (standardType) {
            case 'dtp':
                stepTypeId = 2;
                break;
            case 'TrainingMaterial':
                stepTypeId = 4;
                break;
            default:
                console.log('Throw not implemented');
                stepTypeId = 2;
                break;
        }

        const newStep = {
            content: template.content,
            stepTypeId: stepTypeId,
            duration: 10,
            frequency: 1,
            name: 'Etapa ' + (standard.steps.length + 1),
            instruction: ''
        }
        //numero: standard.steps.length + 1
        setStandard({ ...standard, steps: [...standard.steps, newStep] })
    }

    function newEpi() {
        const newEpi = {
            id: null,
            photo: null
        }
        setStandard({ ...standard, epis: [...standard.epis, newEpi] })
    }

    function newTool() {
        const newTool = {
            id: null,
            photo: null
        }
        setStandard({ ...standard, tools: [...standard.tools, newTool] })
    }

    function handleChangeType(e) {
        const idx = e.target.name.split("_")[0];
        const newstep = standard.steps[idx];

        newstep.stepTypeId = e.target.value
        console.log("Standard original passos " + JSON.stringify(standard.steps))
        console.log("Standard original " + standard.steps[0].stepTypeId)
        console.log("Alterando passo " + newstep.stepTypeId)
        console.log("Content " + newstep.content)

        //trocando de editor para upload de arquivo, limpando o conteudo anterior
        if (standard.steps[0].stepTypeId == 2 && newstep.stepTypeId != 2)
            newstep.content = '';

        if (newstep.stepTypeId == 99)
            newstep.content = '';

        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleChangeName(e, idx) {
        const newstep = standard.steps[idx];
        newstep.name = e.target.value
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleChangeDuration(e, idx) {
        // e.preventDefault();
        const newstep = standard.steps[idx];
        newstep.duration = parseInt(e.target.value)
        if (e.target.value.length > 0 && isNaN(newstep.duration))
            newstep.duration = 1
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleChangeFrequency(e, idx) {
        // e.preventDefault();
        const newstep = standard.steps[idx];
        newstep.frequency = e.target.value
        if (e.target.value.length > 0 && isNaN(newstep.frequency))
            newstep.frequency = 1
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleChangeInstruction(e, idx) {
        // e.preventDefault();
        const newstep = standard.steps[idx];
        newstep.instruction = e.target.value
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });
    }

    function handleChangeTool(e, idx) {
        const newTool = standard.tools[idx];

        let sel = e.target;
        let dataTool = JSON.parse(sel.options[sel.selectedIndex].getAttribute('data-tool'));

        newTool.equipmentId = e.target.value;

        if (dataTool !== null)
            newTool.photo = dataTool.photo
        else
            newTool.photo = null


        setStandard({
            ...standard,
            ...standard.tools.slice(0, idx),
            newTool,
            ...standard.tools.slice(idx + 1)
        });
    }

    function handleChangeEpis(e, idx) {
        const newEpi = standard.epis[idx];

        let sel = e.target;
        let dataEpi = JSON.parse(sel.options[sel.selectedIndex].getAttribute('data-epi'));

        newEpi.equipmentId = e.target.value;

        if (dataEpi !== null)
            newEpi.photo = dataEpi.photo;
        else
            newEpi.photo = null;

        setStandard({
            ...standard,
            ...standard.epis.slice(0, idx),
            newEpi,
            ...standard.epis.slice(idx + 1)
        });
    }

    function selectTemplate(val) {
        const template = templates.find(t => t.standardClassification === val);
        if (template && template.content) {
            const objs = JSON.parse(template.content);
            childRef.current.handleSelectTemplate(objs);
        }
    }

    const changeForm = (event) => {

        if (event.id != undefined) {
            console.log(event.apiurl)
            console.log(event.name)
            console.log(event.id)
            setStandard({ ...standard, [event.apiurl + 'Id']: event.id });
            return;
        }
        let nam = event.target.name;
        let val = event.target.value;
        
        let complementObjectName = '';
        let complementObjectValue = '';
        if (nam.slice(-2).toLowerCase() === 'id') {
            const idx = dadosBasicos.findIndex(i => i.name == nam);

            if (idx > -1) {
                complementObjectName = nam.slice(0, -2)
                const idxOptions = dadosBasicos[idx].options.findIndex(i => i.key == val);

                complementObjectValue = dadosBasicos[idx].options[idxOptions].value
            }
        }

        if (typeof (standard[nam]) === "number") {
            val = parseInt(val)
        }

        if (event.target.name === 'classification' && standard.steps[0].stepTypeId === 2) {
            selectTemplate(val)
        }

        if (event.target.name === 'pilar') {
            standard.speciality = newstd.speciality;//setando default de speciality
        }

        if (complementObjectName != '') {
            console.log(complementObjectName)
            setStandard({ ...standard, [nam]: val, [complementObjectName]: complementObjectValue });
        }
        else
            setStandard({ ...standard, [nam]: val });
    }

    function getSelectItemOptions(item) {
        if (typeof item.options.map !== 'undefined') {
            return <>
                {item.options.map((op) => (
                    (typeof op === "object") ?
                        <option key={'op' + (op.key || op.id)} value={op.key || op.id}> {op.value || op.name} </option>
                        :
                        <option key={'op' + op} value={op}> {op} </option>
                ))}
            </>;
        } else {
            return <>
                {Object.keys(item.options).map((key, index) => (
                    <optgroup label={key} key={index}>
                        {item.options[key].map((op) => (
                            (typeof op === "object") ?
                                <option key={'op' + op.key} value={op.key}> {op.value} </option>
                                :
                                <option key={'op' + op} value={op}> {op} </option>
                        ))}
                    </optgroup>
                ))}
            </>;
        }
    }

    const renderInput = (item, i, array, advancedMenu = undefined) => {

        if (item.advanced !== advancedMenu)
            return

        if (item.reference != undefined) {
            const references = item.reference.split('.');
            if (standardType == 'idcard' && references[0] == 'defectCategory' && standard[references[0]] == '') {
                const idx = dadosBasicos.findIndex(i => i.name == 'defectCategoryId');
                let initialDefectCategory = '';
                if (idx > -1 && dadosBasicos[idx].options.length > 0) {
                    let initialDefectCategory = dadosBasicos[idx].options[0].value;
                    setStandard({
                        ...standard,
                        defectCategory: initialDefectCategory
                    })
                }
            }

            if ((typeof standard[references[0]] !== 'undefined')) {
                let name = standard[references[0]].name;
                if ((typeof name !== 'string'))
                    name = standard[references[0]];

                if ((typeof name === 'string'))
                    name = name.toLowerCase()

                if (name != references[1].toLowerCase()) {
                    return '';
                }
            }
        }
        if (item.options === 'selectasyncpaginate') {
            var value = null;
            if (typeof standard[item.name.slice(0, -2)] !== 'undefined') {
                value = {
                    id: standard[item.name.slice(0, -2)].id,
                    name: standard[item.name.slice(0, -2)].name
                }
            }
            return (
                <div key={'combo' + i.toString()} className={item.class}>
                    <p className='m-0'>{item.desc}</p>
                    <SelectAsyncPaginateGeneric
                        apiurl={item.name.slice(0, -2)} //removing id from the name
                        preload={true}
                        filterFactory={true}
                        onChangeCallback={changeForm}
                        value={value}
                    />
                </div>
            )
        }

        if (item.options === 'checkbox') {
            var value = false;

            return (
                <div key={'combo' + i.toString()} className={item.class}>
                    <p className='m-0'>{item.desc}</p>
                    <input type='checkbox'
                        style={{ width: "50%", height: "50%", align: 'left' }}
                        name={item.name} checked={standard[item.name]}
                        onChange={(e) => changeForm({ target: { name: item.name, value: !standard[item.name] } })}
                    />
                </div>
            )
        }

        if (!item.options) {
            if (item.class !== 'date') {
                return (
                    <div key={'input' + i.toString()} className={item.class}>
                        <p className='m-0'>{item.desc}</p>
                        <input type='text'
                            className={`form-control ${errors.hasError && errors[item.name] ? 'is-invalid' : ''}`}
                            name={item.name} value={standard[item.name]}
                            onChange={e => changeForm(e)}
                        />

                        {errors.hasError && errors[item.name] &&
                            <div className="invalid-feedback">
                                {errors[item.name]}
                            </div>
                        }
                    </div>
                )
            } else {
                const month = new Date().getMonth() + 1;
                const day = new Date().getDate();
                const today = new Date().getFullYear() + "-" + (month > 9 ? month : '0' + month) + "-" + (day > 9 ? day : '0' + day);
                const date = (standard[item.name]) ? standard[item.name].split('T')[0] : null;

                return (
                    <div key={'input' + i.toString()} className='col-4'>
                        <p className='m-0'>{item.desc}</p>
                        <TextField type='date' name={item.name} value={date}
                            onChange={e => changeForm(e)}
                        />
                    </div>
                )
            }
        }
        else {
            const v = item.name in standard ? standard[item.name] : '';
            if (standard[item.name] == 0 && item.options.length > 0) {
                setStandard({
                    ...standard,
                    [item.name]: item.options[0].key
                })
            }
            return (
                <div key={'combo' + i.toString()} className={item.class}>
                    <p className='m-0'>{item.desc}</p>
                    <select id={'sel' + item.name} name={item.name}
                        className={`w-100 form-control ${errors.hasError && errors[item.name] ? 'is-invalid' : ''}`}
                        value={v}
                        onChange={e => changeForm(e)}>
                        {<option hidden selected>Selecione uma opção...</option>}
                        {getSelectItemOptions(item)}
                    </select>
                    {errors.hasError && errors[item.name] &&
                        <div className="invalid-feedback">
                            {errors[item.name]}
                        </div>
                    }
                </div>
            )
        }
    }

    const renderInputAdvanced = (item, i) => {
        if (item.advanced)
            return renderInput(item, i, [], true);
        else
            return ''
    }

    const removeStep = (idx) => {
        setStandard({
            ...standard, steps: [
                ...standard.steps.slice(0, idx),
                ...standard.steps.slice(idx + 1)]
        });
    }

    const removeEpi = (idx) => {
        setStandard({
            ...standard, epis: [
                ...standard.epis.slice(0, idx),
                ...standard.epis.slice(idx + 1)]
        });
    }

    const removeTool = (idx) => {
        setStandard({
            ...standard, tools: [
                ...standard.tools.slice(0, idx),
                ...standard.tools.slice(idx + 1)]
        });
    }

    const getFileName = (url) => {
        let fileName = url.split("/").reverse()[0].split("_");
        fileName.shift();
        fileName = fileName.join("_");
        return fileName;
    }

    const handleCloseIdcardStatus = () => {
        ///setStandard({...standard, eliminated:false, eliminatedAt:'', killerAction:'', toolElimination:''})
        setModalIdcardStatus(false);
    }

    const handleClose = () => {
        setModal(false);
        localStorage.removeItem('step-id')
    }

    async function handleCloseModalDoc(standardId, standardType, wasAStandardSelected = true) {

        if (!wasAStandardSelected)
            return;

        setModal(false);

        let idx = localStorage.getItem('step-id');
        const newstep = standard.steps[idx];
        newstep.externalDocumentId = standardId;
        setStandard({
            ...standard,
            ...standard.steps.slice(0, idx),
            newstep,
            ...standard.steps.slice(idx + 1)
        });

        localStorage.removeItem('step-id')
    }

    const handleShow = (e, idx) => {
        localStorage.setItem('step-id', idx);
        setModal(true);
    }

    /**
     * Update state snackbar for close
     */
    const handleCloseSnackbar = async => {
        setTimeout(function () {
            setSnackBar({ ...snackBar, isOpen: false, message: '' })
        }, 3000);
    }



    const handleSelectStandard = (e, isMachine = false) => {
        if (!isMachine && e) {
            let machineArray = recursiveGetMachinesByKey(e.id, treeData, []);
            setMachine(machineArray);
        }
        //console.log(e);
        setStandard({ ...standard, StructureId: e ? e.id : null });
    }

    let usersToUseL = usersToUse

    function getDepartments() {

        let filters = filtersPopup;

        if (typeof filters['group'] !== 'undefined' && filters['group'] !== '') {

            usersToUseL = usersToUseL.filter(function (item) {
                if (!item.companyRole.name.toLowerCase().includes(filters['group'].toLowerCase()))
                    return false;
                return true;
            });

        }

        if (typeof filters['name'] !== 'undefined' && filters['name'] !== '') {
            usersToUseL = usersToUseL.filter(function (item) {
                if (!item.name.toLowerCase().includes(filters['name'].toLowerCase()))
                    return false;
                return true;
            });
        }

        if (typeof filters['department'] !== 'undefined' && filters['department'] !== 'Todos') {
            usersToUseL = usersToUseL.filter(function (item) {
                if (item.deparment == null)
                    return false;
                if (item.deparment.id != filters['department'])
                    return false;
                return true;
            });

        }

        return <>
            {usersToUseL.map((user, idx) => {
                user.key = user.id;
                return (
                    <tr key={user.id}>
                        <td><input type="checkbox" checked={user.checked} id={user.id} name='user-select' data-user={JSON.stringify(user)} onClick={(e) => selectUser(e, idx)} /></td>
                        <td>{user.name}</td>
                        <td>{user.deparment && user.deparment.name ? user.deparment.name : 'Setor inválido'}</td>
                        <td>{user.sap}</td>
                        <td>{user.companyRole.name.substr(0, user.companyRole.name.indexOf(" "))}</td>
                    </tr>
                )
            })}
        </>;
    }

    const selectUser = (event, idx) => {
        usersToUseL[idx].checked = event.target.checked
        usersToUse[usersToUseL[idx].originalIndex].checked = event.target.checked
        setUsersToUse(usersToUse)
        set(change + 1)
    }

    const newUser = () => {
        setModalUser(true);

        let filters = [];
        filters['group'] = '';
        filters['name'] = '';
        setFiltersPopup(filters);
    }

    const removeUser = (idx) => {
        setStandard({
            ...standard, trainingUsers: [
                ...standard.trainingUsers.slice(0, idx),
                ...standard.trainingUsers.slice(idx + 1)]
        });
    }

    const handleCloseUser = (e, save = false) => {

        if (save) {

            let users = standard.trainingUsers

            let elements = usersToUse;
            for (let i in elements) {
                if (elements[i].checked) {
                    let obj = {
                        status: false,
                        userId: elements[i].id,
                        isInFarol: true
                    }
                    obj.user = elements[i];
                    let check = false;
                    for (let x in users) {
                        if (users[x].userId == obj.user.id) {
                            check = true;
                        }
                    }
                    if (!check) {
                        users.push(obj);
                    }

                }
            }
            setStandard({ ...standard, trainingUsers: users })
        }
        setModalUser(false);

        usersToUse.map((user, idx) => {
            user.checked = false;
        })
    }

    const setFunctionGroup = (value, type) => {

        let filters = [...filtersPopup];
        filters[type] = value;
        setFiltersPopup(filters);
    }

    const imageStorage = (e, step, idx) => {

        let accept = "." + types.find(type => type.stepTypeId === step.stepTypeId).stepType;

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (progressEvent) {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgressNumber(percentCompleted);
            }
        }

        if (e) {
            setIsSaving(true);
            const file = e.target.files[0];
            var formData = new FormData();
            formData.append(file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase(), file);
            console.log(file)
            api.post('standard/uploadFiles', formData, config)
                .then((response) => {

                    setProgressNumber(0);
                    setIsSaving(false);
                    if (accept === "image/*") {
                        setImgState([response.data[file.name.toLowerCase()], ...imgstate]);
                    } else {
                        var newstep = standard.steps[idx];
                        var obj = response.data;
                        var filePath = obj[Object.keys(obj)[0]];
                        newstep.content = filePath;
                        
                        if (!newstep.content.includes('job-') && newstep.stepTypeId == 99) {
                            ShowError("Erro no upload do vídeo, tente novamente!");
                            newstep.content = '[]';
                        }
                        handleChangeStep(newstep, idx);
                        handleClose();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    setIsSaving(false);
                    ShowError("Erro no upload do arquivo, tente novamente!");
                });
        }
    }

    function getNameCurrentStructure() {
        let currentStructure = '';
        if (standard.StructureId && allStructuresData.length > 0) {
            let currentStructureObject = _.first(allStructuresData.filter((item) => {
                return item.id === standard.StructureId
            }));
            if (currentStructureObject)
                currentStructure = `(Atual: ${currentStructureObject.name})`;
        }
        return currentStructure
    }

    function getImgEquipament(equipament) {
        if (equipament !== null && equipament.photo !== null)
            return <div className='mx-auto text-center'>
                <img width={80} height={80} src={equipament.photo + '?' + mediatoken} alt="Imagem do equipamento" />
            </div>;
    }

    function getDadosBasicosHeaderTitle() {
        return (standardType === 'idcard') ? "Descrição do Modo Defeito" : "Cabeçalho";
    }

    const getObservationLabel = () => {
        switch (standardType) {
            default:
            case 'dtp':
                return 'Instruções';
            case 'lpp':
                return 'Propósito da LPP';
            case 'idcard':
            case 'TrainingMaterial':
                return 'Observações';
        }
    }

    function handleShowInstructionRPN(control = false) {
        setInstructionRPN(control);
    }

    function selecionarTodos(user) {
        for (var i = 0; usersToUseL.length > i; i++) {
            user[i].checked = true;
            usersToUse[usersToUseL[i].originalIndex].checked = true;
        }
        setUsersToUse(usersToUse)
        set(change + 1)
    }

    function deselecionarTodos(user) {
        for (var i = 0; user.length > i; i++) {
            user[i].checked = false;
            usersToUse[usersToUseL[i].originalIndex].checked = false;
        }
        setUsersToUse(usersToUse)
        set(change + 1)
    }

    return (
        <>
            {
                standard.identifier &&
                <Card key={'identifier-base'} >
                    <CardHeader title={<strong>{standard['identifier']}</strong>} className='text-center' />
                </Card>
            }
            <div style={{ position: 'relative' }}>
                {
                    load ?
                        <Loading /> : null
                }
                {
                    showAlert != null ? <Alert className="mb-4 mt-4" variant={showAlert.variant} > {showAlert.message}</Alert > :
                        <div className='d-flex flex-column'>
                            <div className='mt-2 row'>
                                <div className='col-4'>
                                    <div key={'inputname'} className='mx-2 my-2 flex-grow-2'>
                                        <p className='m-0'>{standardType !== 'idcard' ? 'Nome do documento' : 'Modo de Defeito'}</p>
                                        <input type='text'
                                            maxLength={250}
                                            className={`form-control ${(errors.hasError && errors.Name) || standard['name']?.length == 250 ? 'is-invalid' : ''}`}
                                            name={'name'} value={standard['name']}
                                            onChange={e => changeForm(e)}
                                        />
                                        {
                                            errors.hasError && errors.Name
                                                ? <div class="invalid-feedback">
                                                    {errors.Name}
                                                </div>
                                                : ""
                                        }
                                        {
                                            standard['name']?.length == 250 &&
                                            <div class="invalid-feedback">
                                                Limite de 250 letras atingido para o nome do documento
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    standardType !== 'idcard' &&
                                    <div className='col-4'>
                                        <div key={'combo0'} className='mx-2 my-2 flex-grow-2'>
                                            <p className='m-0'>Setor/Linha/Pilar <strong>{getNameCurrentStructure()}</strong></p>
                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={setorLinhaData}
                                                getOptionLabel={(option) => option.name + (option.father ? (' (' + option.father.name + ')') : '')}
                                                style={{ width: '100%' }}
                                                className={`form-control ${errors.hasError && errors.Structure ? 'is-invalid' : ''}`}
                                                onChange={(event, newValue) => {
                                                    handleSelectStandard(newValue);
                                                }}
                                                renderInput={(params) => <TextField {...params} label="" />}
                                            />
                                            {
                                                errors.hasError && errors.Structure
                                                    ? <div class="invalid-feedback">
                                                        {errors.Structure}
                                                    </div>
                                                    : ""
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    !isEmptyArray(machine) ?
                                        <div className='col-4'>
                                            <div key={'combo0'} className='mx-2 my-2 flex-grow-2'>
                                                <div>
                                                    <p className='m-0'>Máquinas/Ativos <strong>{getNameCurrentStructure()}</strong></p>
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={machine}
                                                        getOptionLabel={(option) => option.name + (option.father.name ? (' (' + option.father.name + ')') : ' (' + option.father + ')')}
                                                        style={{ width: '100%' }}
                                                        className={`form-control ${errors.hasError && errors.Machines ? 'is-invalid' : ''}`}
                                                        onChange={(event, newValue) => {
                                                            handleSelectStandard(newValue, true);
                                                        }}
                                                        renderInput={(params) => <TextField {...params} label="" />}
                                                    />
                                                    {
                                                        errors.hasError && errors.Machines
                                                            ? <div class="invalid-feedback">
                                                                {errors.Machines}
                                                            </div>
                                                            : ""
                                                    }
                                                </div>
                                                {
                                                    standardType !== 'idcard' &&
                                                    <div>
                                                        <LightTooltip
                                                            arrow
                                                            title="Documentos (LPP, DTP) podem ser criados em um LL,
                                        departamento, linha ou direto em máquinas e ativos.
                                        Portanto esse campo é opcional, preencha somente
                                        se quiser que o documento seja específico de uma máquina/ativo."
                                                        >
                                                            <span>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    className={classes.button}
                                                                    startIcon={<Icon>info</Icon>}
                                                                >
                                                                    Info
                                                                </Button>
                                                            </span>
                                                        </LightTooltip>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        : ''
                                }


                            </div>

                            {(redirect !== '/new/0') && <Redirect to={redirect} />}
                            <form className='d-flex my-5 flex-wrap'>
                            </form>
                            <div>
                                <Card key={'step-base'} >
                                    <CardHeader title={getDadosBasicosHeaderTitle()} />
                                    <CardBody>
                                        <div className='row w-100'>
                                            {dadosBasicos.map(renderInput)}
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>

                            {standardType === 'idcard' && standard['rpn'] == false &&
                                <div>
                                    {instructionRPN &&
                                        <div className='mt-2 row'>
                                            <GalleryLightbox images={images} style={{ width: 514, height: 560, margin: '0 auto' }}
                                                isOpenDefault={true} closeCallback={handleShowInstructionRPN} />
                                        </div>
                                    }
                                    <div>
                                        <Card key={'step-base'} >
                                            <CardHeader title={"Avaliação de RPN do defeito"} />
                                            <CardBody>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    startIcon={<Icon>info</Icon>}
                                                    onClick={(e) => handleShowInstructionRPN(true)}>
                                                    Instruções do RPN
                                                </Button>
                                                <div className='row w-100'>
                                                    {dadosBasicos.map(renderInputAdvanced)}
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>
                            }


                            {standardType === 'dtp' &&
                                <div className='row mt-5 no-gutters'>

                                    <div className='col-6 card'>
                                        <h2 className='w-100 text-center card-header'>
                                            EPIS
                                            <Button variant="contained" color="primary" className='float-right' onClick={() => {
                                                newEpi()
                                            }}>Adicionar</Button>
                                        </h2>
                                        <div className='row card-body'>
                                            {standard.epis.map((epi, idx) => (
                                                <div className='item-epi col-4 mb-3' key={idx}>
                                                    <div className='d-inline-flex'>
                                                        <select className='form-control' value={epi.equipmentId} onChange={(e) => handleChangeEpis(e, idx)}>
                                                            <option value={null}>-</option>
                                                            {epis.map((op) => (
                                                                (typeof op === "object") ?
                                                                    <option key={'op' + (op.key || op.id)} data-epi={JSON.stringify(op)}
                                                                        value={op.key || op.id}> {op.value || op.name} </option>
                                                                    :
                                                                    <option key={'op' + op} value={op} data-epi={op}> {op} </option>
                                                            ))}
                                                        </select>
                                                        <div className='flex-fill d-block justify-content-end '>
                                                            <button className='btn-sm btn-danger fas fa-trash p-3' onClick={() => removeEpi(idx)} />
                                                        </div>
                                                    </div>
                                                    {getImgEquipament(epi)}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className='col-6 card'>
                                        <h2 className='w-100 text-center card-header'>
                                            Ferramentas/Dispositivos
                                            <Button variant="contained" color="primary" className='float-right' onClick={() => {
                                                newTool()
                                            }}>Adicionar</Button>
                                        </h2>
                                        <div className='row card-body'>
                                            {standard.tools.map((tool, idx) => (
                                                <div className='item-epi col-4 mb-3' key={idx}>
                                                    <div className='d-inline-flex'>
                                                        <select className='form-control' value={tool.equipmentId} onChange={(e) => handleChangeTool(e, idx)}>
                                                            <option value={null}>-</option>
                                                            {tools.map((op) => (
                                                                (typeof op === "object") ?
                                                                    <option key={'op' + (op.key || op.id)} data-tool={JSON.stringify(op)}
                                                                        value={op.key || op.id}> {op.value || op.name} </option>
                                                                    :
                                                                    <option key={'op' + op} value={op} data-tool={op}> {op} </option>
                                                            ))}
                                                        </select>
                                                        <div className='flex-fill d-block justify-content-end '>
                                                            <button className='btn-sm btn-danger fas fa-trash p-3' onClick={() => removeTool(idx)} />
                                                        </div>
                                                    </div>
                                                    {getImgEquipament(tool)}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }
                            {(standardType === 'dtp') &&
                                <div className='mx-auto mt-5'>
                                    <h2 className=''>Passos </h2>
                                </div>}


                            <div>
                                {standard.steps.map((step, idx) => (
                                    <Card key={'step-' + idx}>
                                        <CardHeader
                                            title={standardType === 'dtp' ? (
                                                <div className="d-flex fle">
                                                    <h3>{(idx + 1).toString()}</h3>
                                                    {(
                                                        <div className="ml-4">
                                                            <Tooltip title="Mover para cima">
                                                                <span>
                                                                    <Button variant="contained" size="small" className="mr-2"
                                                                        color="secondary"
                                                                        disabled={idx === 0}
                                                                        onClick={() => {
                                                                            handleSwapSteps(idx, idx - 1)
                                                                        }}
                                                                    >
                                                                        <ArrowUpwardIcon />
                                                                    </Button>
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip title="Mover para baixo">
                                                                <span>
                                                                    <Button variant="contained" size="small"
                                                                        color="secondary"
                                                                        disabled={idx >= (standard.steps.length - 1)}
                                                                        onClick={() => {
                                                                            handleSwapSteps(idx, idx + 1)
                                                                        }}
                                                                    >
                                                                        <ArrowDownwardIcon />
                                                                    </Button>
                                                                </span>
                                                            </Tooltip>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : ''}
                                            id={'p' + idx}
                                            className='d-flex flex-wrap'
                                        />

                                        <CardBody>

                                            <Grid container justify="space-around">
                                                <FormControl className="w-100 d-flex" style={{ minWidth: '10%' }}>
                                                    <div className='d-flex flex-fill'>
                                                        <Select
                                                            id={"type_" + idx}
                                                            value={standard.steps[idx].stepTypeId}
                                                            onChange={handleChangeType}
                                                            input={<Input id={idx + "_input_select"} />}
                                                            displayEmpty
                                                            name={idx + "_type_select"}
                                                            className='d-flex justify-content-start'
                                                        >
                                                            {standardType !== 'TrainingMaterial' && <MenuItem value={2}>Editor</MenuItem>}
                                                            {standardType.toLowerCase() !== 'dtp' && <MenuItem value={4}>PDF</MenuItem>}
                                                            {(standardType === 'TrainingMaterial' || standardType.toLowerCase() === 'lpp') && <MenuItem value={8}>Excel</MenuItem>}
                                                            {standardType === 'TrainingMaterial' && <MenuItem value={7}>Word</MenuItem>}
                                                            {standardType === 'TrainingMaterial' && <MenuItem value={9}>PowerPoint</MenuItem>}
                                                            <MenuItem value={99}>Vídeo</MenuItem>
                                                        </Select>

                                                        <Button variant="outlined" onClick={(e) => handleShow(e, idx)}>Linkar a outro
                                                            documento</Button>

                                                        {(standardType === 'dtp') && <>
                                                            <div className='w-50 pl-2'>
                                                                <label className='w-100'>
                                                                    Nome dessa etapa
                                                                    <input className='form-control w-100'
                                                                        maxLength={50}
                                                                        key={'etapa-name-' + idx}
                                                                        onChange={(e) => handleChangeName(e, idx)}
                                                                        value={standard.steps[idx].name}
                                                                        placeholder='Escreva aqui o nome dessa etapa'
                                                                        className={`form-control ${(errors.hasError && errors.Name) || standard.steps[idx].name?.length == 50 ? 'is-invalid' : ''}`}
                                                                        name={'etapa-name-' + idx} />
                                                                    {
                                                                        errors.hasError && errors.Name
                                                                            ? <div class="invalid-feedback">
                                                                                {errors.Name}
                                                                            </div>
                                                                            : ""
                                                                    }
                                                                    {
                                                                        standard.steps[idx].name?.length == 50 &&
                                                                        <div class="invalid-feedback">
                                                                            Limite de 50 letras atingido para o nome da etapa
                                                                        </div>
                                                                    }
                                                                </label>
                                                            </div>
                                                            <div className='w-50 pl-2 pr-2'>
                                                                <label className='w-100'>
                                                                    Duração ( em segundos)
                                                                    <input className='form-control w-100'
                                                                        key={'etapa-duration-' + idx}
                                                                        type='number'
                                                                        onChange={(e) => handleChangeDuration(e, idx)}
                                                                        value={standard.steps[idx].duration}
                                                                        placeholder='1' name={'etapa-duration-' + idx} />
                                                                </label>
                                                            </div>
                                                            <div className='w-50 pl-2 pr-2'>
                                                                <label className='w-100'>
                                                                    Repetir a etapa (vezes)
                                                                    <input className='form-control w-100'
                                                                        key={'etapa-frequency-' + idx}
                                                                        type='number'
                                                                        onChange={(e) => handleChangeFrequency(e, idx)}
                                                                        value={standard.steps[idx].frequency}
                                                                        placeholder='1' name={'etapa-frequency-' + idx} />
                                                                </label>
                                                            </div>
                                                        </>}

                                                        {
                                                            step.stepTypeId !== 2 &&
                                                            <>
                                                                <input
                                                                    type="file"
                                                                    id="imageFile"
                                                                    name='imageFile'
                                                                    onChange={(e) => imageStorage(e, step, idx)}
                                                                    accept={"." + types.find(type => type.stepTypeId === step.stepTypeId).stepType}
                                                                />
                                                                {
                                                                    progressNumber !== 0 &&
                                                                    <ProgressBar className={'w-100 d-block'} style={{ height: '30px' }} now={progressNumber} variant={progressNumber > 99 ? "warning" : "success"}
                                                                        label={progressNumber > 99 ? 'Preprocessando...aguarde por favor' : `${progressNumber}%`} />
                                                                }
                                                            </>
                                                        }
                                                        {((standardType === 'dtp' || standardType === 'TrainingMaterial') && idx > 0) &&
                                                            <>
                                                                <div className='flex-fill d-block justify-content-end pt-5'>
                                                                    <button className='fas fa-trash btn-small btn-danger p-3 rounded'
                                                                        onClick={() => removeStep(idx)} />
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </FormControl>

                                                <div className='row w-100'>
                                                    <div className='col-2 pt-5'>
                                                        {(typeof step.externalDocumentId !== 'undefined' && step.externalDocumentId !== null) &&
                                                            <>
                                                                <div className='w-100'>
                                                                    <Button variant="outlined">{step.externalDocumentId}</Button>
                                                                </div>
                                                                <div className="mb-4">
                                                                    <Link to={generatePath('/standard/ref/:id', { id: step.externalDocumentId })} className="btn btn-outline-info" target="_BLANK">
                                                                        Documento Adicional
                                                                    </Link>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                    <div className='w-100'>
                                                        {step.stepTypeId !== 2 &&
                                                            <>
                                                                <Button onClick={() => setArchiveView(prev => !prev)} className="btn btn-success" style={{padding: '8px 22px', display: 'flex', width: 'fit-content', alignItems: 'flex-end', marginBottom: '20px'}}>{archiveView ? 'Esconder': 'Visualizar'} Arquivo { archiveView ? (
                                                                    <AiFillEyeInvisible style={{fontSize: '22px', marginLeft: '8px'}} />
                                                                ): (
                                                                    <AiFillEye style={{fontSize: '22px', marginLeft: '8px'}} />
                                                                )}
                                                                </Button>
                                                                {(step.content !== '' || step.content !== []) && archiveView ? (
                                                                    <Render step={step} standardType='lpp' style={{ minHeight: '65rem' }} />)
                                                                    :
                                                                    (
                                                                        <h2>
                                                                            <a target='_blank' href={step.content + '?' + mediatoken}>
                                                                                {getFileName(step.content)}
                                                                            </a>
                                                                        </h2>
                                                                )}
                                                            </>
                                                        }
                                                        {step.stepTypeId === 2 &&
                                                            <Editor ref={childRef} standard={standard} handleChange={handleChange}
                                                                idx={idx} standardType={standardType} />}
                                                    </div>
                                                </div>
                                                {(standardType !== '') &&
                                                    <div className='w-100 d-flex flex-column' style={{marginTop: '20px'}}>
                                                        <div className='align-self-center'>
                                                            <h1>{getObservationLabel()}</h1>
                                                        </div>
                                                        <textarea value={standard.steps[idx].instruction} className='w-100' rows={3} cols={50} height='5rem' style={{ resize: 'none' }} onChange={(e) => handleChangeInstruction(e, idx)}>
                                                        </textarea>
                                                    </div>
                                                }
                                            </Grid>
                                        </CardBody>
                                    </Card>
                                ))}
                            </div>

                            {(standardType === 'dtp' || standardType === 'TrainingMaterial') &&
                                <div className='mt-2 col-4'>
                                    <Icon className='fa fa-plus-circle cursor-pointer' onClick={() => newStep()} />
                                </div>}

                            {/*training area*/}
                            { standard.identifier &&
                                <div>
                                    <div className="mt-2">
                                        <div className="mt-2 d-flex">
                                            <Typography className="float-center" variant="h4">Colaboradores em Treinamento</Typography>
                                        </div>
                                        <div className="mb-4">
                                            <TrainingTable editTraining={false} viewOnly={true} standard={standard} />
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className='justify-content-between row mt-5'>

                                {isSaving &&
                                    <div className='w-100 text-center mx-auto'>
                                        <CircularProgress />
                                    </div>
                                }

                                {!isSaving &&
                                    <div className=' col-3'>
                                        <Button id="Salvar" variant="contained" color="primary" className='float-right' onClick={() => {
                                            BeforeSaveData()
                                        }}>Salvar e Continuar</Button>
                                    </div>
                                }

                                {!isSaving &&
                                    <div className=' col-3'>
                                        <Button className="btn btn-success float-left" onClick={() => {
                                            BeforeSaveData(false, false, true) //for_approval : false, bypassApprovalFlow : false, for_training : true
                                        }}>
                                            Salvar e Editar treinamentos
                                        </Button>
                                    </div>
                                }

                                {userAcessLevel >= 7 && !isSaving &&
                                    <div className=' col-3'>
                                        <Button id="SalvarAdmin" variant="contained" color="secondary" className='float-left' onClick={() => {
                                            BeforeSaveData(true, true)
                                        }}>Salvar e aprovar (admin)</Button>
                                    </div>
                                }
                                {standardType === 'idcard' &&
                                    <div className=' col-3'>
                                        <Button id="eliminarDefeito" variant="contained" color={standard.eliminated ? 'info' : 'info'} className='float-left'
                                            onClick={() => {
                                                setModalIdcardStatus(true)
                                            }}>
                                            {standard.eliminated ? 'Reativar ID Card' : 'Eliminar Modo de Defeito'}</Button>
                                    </div>
                                }
                                {!isSaving &&
                                    <>
                                        {workFlowOnline ?
                                            <>
                                                {workFlowOnline.editable == true ?
                                                    <Link to={{
                                                        pathname: `/approval/${workFlowOnline.id}`,
                                                        state: {}
                                                    }}>
                                                        <Button id="EditWorkflow" variant="contained" color="secondary" className='float-right'>
                                                            Editar Fluxo
                                                        </Button>
                                                    </Link>
                                                    :
                                                    <Badge variant='warning'>Fluxo de aprovação em andamento</Badge>
                                                }
                                            </>
                                            :
                                            <div className=' col-3'>
                                                <Button id="SalvarWorkflow" variant="contained" color="primary" className='float-right' onClick={() => {
                                                    BeforeSaveData(true)
                                                }}>Salvar e Enviar para aprovação</Button>
                                            </div>
                                        }
                                    </>
                                }
                            </div>

                            <ExternalStandardModal
                                structureId={standard.StructureId}
                                showModalDoc={modal}
                                standardOptions={externalStandardOptions}
                                onHide={handleClose}
                                onAccept={handleCloseModalDoc} />

                            <Modal show={modalIdcardStatus} size={'lg'}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Status do ID Card</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ overflow: 'auto', maxHeight: '500px' }}>
                                    {standard.eliminated ?
                                        <div className='row w-100'>
                                            {dadosIdcardStatus[1].map(renderInput)}
                                        </div>
                                        :
                                        <div className='row w-100'>
                                            {dadosIdcardStatus[0].map(renderInput)}
                                        </div>
                                    }
                                </Modal.Body>
                                <Modal.Footer>
                                    <div className='justify-content-between row mt-1'>
                                        <div><Button variant="contained"
                                            onClick={handleCloseIdcardStatus}>
                                            Cancelar
                                        </Button></div>
                                        <div><Button variant="contained" color="primary"
                                            onClick={(e) => {
                                                if (standard.eliminated)
                                                    setStandard({
                                                        ...standard, eliminated: !standard.eliminated,
                                                        killerAction: '', eliminatedAt: null, toolElimination: ''
                                                    })
                                                else
                                                    setStandard({
                                                        ...standard, eliminated: !standard.eliminated,
                                                        reactivationReason: '',
                                                        reactivationSource: '',
                                                        reactivateAt: null,
                                                    })
                                                setModalIdcardStatus(false);
                                            }}>
                                            {standard.eliminated ? 'Confirmar Reativação' : 'Confirmar Eliminação'}
                                        </Button></div>
                                    </div>
                                </Modal.Footer>
                            </Modal>

                            <Modal style={{ position: "absolute", top: "50%" }} show={modalUser} onHide={handleCloseUser} size={'lg'}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Colaboradores</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ overflow: 'auto', maxHeight: '400px' }}>
                                    <div className='filters'>
                                        <label className='w-100'>
                                            <LightTooltip title="Essa lista mostra somente setores/linhas que tem colaboradores associadas a elas via centro de custo.">
                                                <Typography className="tittleFiltros" >Filtro por Setores/Linhas</Typography>
                                            </LightTooltip>
                                            <select className='form-control' onChange={(e) => setFunctionGroup(e.target.value, 'department')}>
                                                <option value={null}>Todos</option>
                                                {setores.map((op) => (
                                                    <option key={'op' + op.id} data-epi={JSON.stringify(op)}
                                                        value={op.id}> {op.name} </option>
                                                ))}
                                            </select>
                                        </label>
                                        <label className='w-100'>
                                            Filtro de grupo de função
                                            <input className='form-control' onChange={(e) => setFunctionGroup(e.target.value, 'group')} />
                                        </label>
                                        <label className='w-100'>
                                            Filtro pelo nome
                                            <input className='form-control' onChange={(e) => setFunctionGroup(e.target.value, 'name')} />
                                        </label>
                                    </div>

                                    <div className='card'>
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <td></td>
                                                    <td>Nome</td>
                                                    <td>Departamento</td>
                                                    <td>SAP</td>
                                                    <td>Grupo de Função</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getDepartments()}
                                            </tbody>
                                        </table>

                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => selecionarTodos(usersToUseL)}>
                                        Marcar Todos
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => deselecionarTodos(usersToUseL)}>
                                        Desmarcar Todos
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={(e) => handleCloseUser(e, true)}>
                                        Selecionar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.button}
                                        onClick={handleCloseUser}>
                                        Cancelar
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Snackbar
                                open={snackBar.isOpen}
                                anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                                key={snackBar.vertical + snackBar.horizontal}
                                autoHideDuration={1000}
                                onClose={(e) => handleCloseSnackbar(e)}
                            >
                                <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                                    {snackBar.message}
                                </AlertHelper>
                            </Snackbar>
                        </div>

                }
            </div>

            <Modal style={{ position: "absolute", top: "50%" }} show={modalMatrixUsers} size={'lg'}>
                <Modal.Header closeButton>
                    <Modal.Title>Inserir colaboradores da Matrix no treinamento?</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ overflow: 'auto', maxHeight: '400px' }}>
                    <Paper>
                    <TableContainer>
                        <Table>
                            <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>SAP</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            { listUserMatrix?.map((object, i)=>(
                                <TableRow key={i}>
                                <TableCell>{object.userName}</TableCell>
                                <TableCell>{object.userSap}</TableCell>
                            </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Paper>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => handleMatrixUsersConfirm()}
                    >
                        Sim
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={handleCloseMatrixUser}
                    >
                        Inserir manualmente
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
